export enum InsurancePolicyStatus {
    InProgress = "InProgress",
    Accepted = "Accepted",
    PolicyIssued = "PolicyIssued",
    Cancelled = "Cancelled",
    Annulled = "Annulled",
}